import firebase from '../firebase';

export const setNotificationLoading = (val) => async (dispatch) => {
  dispatch({ type: 'SET_NOTIFICATION_LOADING', payload: val });
};
export const getNotifications = (u_id) => async (dispatch) => {
  await firebase
    .firestore()
    .collection('notifications')
    .where('notify_to', '==', u_id)
    .where('read', '==', false)
    .orderBy('created_at', 'desc')
    .onSnapshot((query) => {
      var tempNotifications = [];
      query.forEach((doc) => {
        tempNotifications.push({ id: doc.id, ...doc.data() });
      });
      console.log(tempNotifications);
      dispatch({ type: 'GET_NOTIFICATIONS', payload: tempNotifications });
    });
};

export const readSingleNotification = (id) => async (dispatch) => {
  firebase
    .firestore()
    .collection('notifications')
    .doc(id)
    .update({ read: true });
};

export const readAllNotifications = (notificationsData) => async (dispatch) => {
  await dispatch(setNotificationLoading(true));
  notificationsData.forEach((noti) => {
    if (!noti.read) {
      firebase
        .firestore()
        .collection('notifications')
        .doc(noti.id)
        .update({ read: true });
    }
  });
  await dispatch(setNotificationLoading(false));
};

export const deleteNotification = (id) => async (dispatch) => {
  firebase.firestore().collection('notifications').doc(id).delete();
};
